import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'searchable-dropdown',
  template: require('./searchable-dropdown.component.html'),
  styles: [require('./searchable-dropdown.component.css')]
})
export class SearchableDropdownComponent {
  @Input() options: any[] = [];
  @Input() placeholder: string = 'Select';
  @Input() selected: any;
  @Output() selectedChange = new EventEmitter<any>();

  dropdownOpen = false;
  searchText = '';

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any) {
    this.selected = option;
    this.selectedChange.emit(this.selected);
    this.dropdownOpen = false;
    this.searchText = '';
  }

  get filteredOptions() {
    if (!this.searchText) return this.options;
    const text = this.searchText.toLowerCase();
    return this.options.filter(o => o.toLowerCase().includes(text));
  }

  // Close dropdown on click outside
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
      this.dropdownOpen = false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/searchable-dropdown/searchable-dropdown.component.ts